import { dicontainer } from 'DIContainer';
import { injectable } from "inversify";
import PageNavigationController from 'PageNavigation/PageNavigationController';
import PriceUnlockModal from 'Pages/Alcohol/PriceUnlockModal';
import React from 'react';
import HttpService from 'Services/Http/HttpService';
import ServiceRequest from 'Services/ServiceRequest';
import { EventHandler, SimpleEventArgs, Url } from 'ts-common-utils';

@injectable()
export default class BeerService {
    public onPricingUnlocked = new EventHandler<SimpleEventArgs<undefined>>();

    private _httpService: HttpService  = dicontainer.get(HttpService);
    private _isPricingUnlocked: boolean = true;
    private _pageNavigationController: PageNavigationController = dicontainer.get(PageNavigationController);

    public get isPricingUnlocked() {
        return this._isPricingUnlocked
    }

    public showPricingUnlockModal(): void {
        this._pageNavigationController.showModal({name: "price-unlock", title: "Code d'accès", content: <PriceUnlockModal/> });
    }

    public tryUnlockPricing(accessCode: string, onSuccess?: () => void, onFailure?: () => void): ServiceRequest {
        if (String.isNullOrEmpty(accessCode)) {
            onFailure?.();
        }
        return this._httpService.httpGet(
            new Url("./php/validate-beer-price-access-code.php",
                {accessCode: accessCode!}
            ), {
                onSuccess: (json: any) => {
                    this._isPricingUnlocked = true;
                    this.onPricingUnlocked.fire(this, new SimpleEventArgs(undefined));
                    onSuccess?.();
                },
                onFailure: onFailure
            }
        );
    }
}